module.exports = __webpack_public_path__ + "img/117.c6611d34.jpg";